import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Row, Col } from 'antd';
import Format from '../../utils/format';
import { Markup } from 'interweave';

@inject(
    'templateStore',
    'laundryStore',
    'webSettingStore'
)
@observer
class LaundryDetailModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
    }

    // ON CLICK

    modalCloseOnClick = () => {
        this.props.laundryStore.setShowLaundryDetailModal(false);
    }

    render() {
        const { activeTemplate } = this.props.templateStore;

        const {
            menu,
            laundryDetail
        } = this.props.laundryStore;

        const { data: webSettting } = this.props.webSettingStore;

        return (
            <>
                {
                    activeTemplate
                        ?
                        <>
                            {
                                webSettting
                                    ?
                                    <>
                                        {
                                            laundryDetail === null
                                                ?
                                                null
                                                :
                                                <Row>
                                                    <Col span={24} className='stm-margin-bottom-12 stm-text-align-center'>
                                                        {
                                                            laundryDetail.imageUrl === ''
                                                                ?
                                                                <img className='stm-width-60-percent' src={menu ? menu.imageUrl : ''} alt={laundryDetail.taskName} />
                                                                :
                                                                <img className='stm-width-100-percent' src={laundryDetail.imageUrl} alt={laundryDetail.taskName} />
                                                        }
                                                        <img className='stm-modal-image-close' src={require('../../assets/image/CloseModal.svg')} alt='closemodal' onClick={this.modalCloseOnClick} />
                                                    </Col>
                                                    <Col
                                                        span={24}
                                                        className='stm-margin-bottom-4 stm-padding-left-16'
                                                        style={{
                                                            fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                                            color: activeTemplate.templateSetting.label.color,
                                                            fontSize: activeTemplate.templateSetting.label.fontSize,
                                                            lineHeight: `${activeTemplate.templateSetting.label.fontSize + 2}px`
                                                        }}
                                                    >
                                                        {laundryDetail.taskName}
                                                    </Col>
                                                    <Col
                                                        span={24}
                                                        className='stm-margin-bottom-8 stm-padding-left-16'
                                                        style={{
                                                            fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                            color: activeTemplate.templateSetting.text.color,
                                                            fontSize: activeTemplate.templateSetting.text.fontSize,
                                                            lineHeight: `${activeTemplate.templateSetting.text.fontSize + 2}px`
                                                        }}
                                                    >
                                                        {
                                                            laundryDetail.specialPrice === laundryDetail.price
                                                                ?
                                                                <span>{webSettting.currencyCode} {Format.Currency(laundryDetail.price)}</span>
                                                                :
                                                                <>
                                                                    <span>{webSettting.currencyCode} {Format.Currency(laundryDetail.specialPrice)}</span>
                                                                    <span className='stm-text-decoration-line-through stm-padding-left-4'>{Format.Currency(laundryDetail.price)}</span>
                                                                </>
                                                        }
                                                    </Col>
                                                    <Col
                                                        span={24}
                                                        className='stm-modal-detail'
                                                        style={{
                                                            fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                            color: activeTemplate.templateSetting.text.color,
                                                            fontSize: activeTemplate.templateSetting.text.fontSize,
                                                            lineHeight: `${activeTemplate.templateSetting.text.fontSize + 2}px`
                                                        }}
                                                    >
                                                        <Markup content={laundryDetail.taskDesc} />
                                                    </Col>
                                                </Row>
                                        }
                                    </>
                                    :
                                    null
                            }
                        </>
                        :
                        null
                }
            </>
        )
    }
}

export default LaundryDetailModal